export default __webpack_public_path__ + "static/media/log-or-logback-fr.7a3027b4.png";